import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useOptions} from './';

const defaultSystemOptions = {
    site: 'homeaway_us',
    baseUrl: 'https://www.homeaway.com',
    appPrefix: '/',
    pageType: undef,
    locale: 'en_US'
};

function useSystemOptions(props) {
    const {
        systemOptions: propsSystemOptions
    } = props;

    const {
        options: systemOptions
    } = useOptions(defaultSystemOptions, propsSystemOptions);

    const result = {
        systemOptions
    };

    useDebugValue(result);

    return result;
}

export {useSystemOptions};
